.formFieldContainer {
    margin: 0px 10px 20px 0px;
    flex: 1;
}